import { render, staticRenderFns } from "./NewMusicVideo.vue?vue&type=template&id=9e39c040&scoped=true&"
import script from "./NewMusicVideo.vue?vue&type=script&lang=js&"
export * from "./NewMusicVideo.vue?vue&type=script&lang=js&"
import style0 from "./NewMusicVideo.vue?vue&type=style&index=0&id=9e39c040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e39c040",
  null
  
)

export default component.exports